import { render, staticRenderFns } from "./gender-picker.vue?vue&type=template&id=a157885e&scoped=true&lang=pug&"
import script from "./gender-picker.vue?vue&type=script&lang=ts&"
export * from "./gender-picker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a157885e",
  null
  
)

export default component.exports